var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/users/owner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.959 49.9996 0.959 49.9996 28 0 28"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/users/owner",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(15.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6406,5.126 L35.6546,5.111 L31.9996,0.959 L28.7676,4.21 C27.5076,4.124 26.2406,4.068 24.9586,4.068 C23.7026,4.068 22.4606,4.121 21.2266,4.204 L17.9996,0.959 L14.3356,5.097 L14.3496,5.111 C9.2866,6.104 4.4666,7.775 -0.0004,10.049 L-0.0004,28 L49.9996,28 L49.9996,10.09 C45.5326,7.807 40.7076,6.126 35.6406,5.126",
    id: "Fill-1",
    fill: "#91A1B5",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36,21 L14,21 C12.896,21 12,20.104 12,19 L12,16 C12,14.896 12.896,14 14,14 L36,14 C37.104,14 38,14.896 38,16 L38,19 C38,20.104 37.104,21 36,21",
    id: "Fill-4",
    fill: "#C29F82"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#C29F82",
    points: "32 26 18 26 18 31.958 25 39 32 31.958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.958,20 C35.958,26.075 31.033,31 24.958,31 C18.883,31 14,26.075 14,20 L14,11 C14,4.925 18.883,0 24.958,0 C31.033,0 35.958,4.925 35.958,11 L35.958,20 Z",
    id: "Fill-8",
    fill: "#F0C6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,14 L35,18.589 C35,21.578 33.988,23 31,23 C29.853,23 27,22 25,22 C23,22 20.147,23 19,23 C16.012,23 15,21.578 15,18.589 L15,14 L14,14 L14.046,22.147 C14.046,28.221 18.928,33.146 25.002,33.146 C31.076,33.146 36,28.221 36,22.147 L35.958,14 L35,14 Z",
    id: "Fill-10",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,14 C23.5,15.933 21.933,17.5 20,17.5 C18.067,17.5 16.5,15.933 16.5,14 C16.5,12.067 18.067,10.5 20,10.5 C21.933,10.5 23.5,12.067 23.5,14 Z",
    id: "Stroke-12",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,14 C33.5,15.933 31.933,17.5 30,17.5 C28.067,17.5 26.5,15.933 26.5,14 C26.5,12.067 28.067,10.5 30,10.5 C31.933,10.5 33.5,12.067 33.5,14 Z",
    id: "Stroke-14",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5645,12.8848 C26.0915,12.6468 25.5655,12.4998 25.0005,12.4998 C24.4345,12.4998 23.9085,12.6468 23.4355,12.8848",
    id: "Stroke-16",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,13.5 L14,13.5",
    id: "Stroke-18",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,13.5 L33,13.5",
    id: "Stroke-20",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#313036",
    points: "29 43 25 47 21 43 25 39"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#313036",
    points: "29 59 25 59 21 59 23 42 27 42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    opacity: 0.5,
    transform: "translate(14.000000, 31.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    points: "15 12 21.654 5.111 18 0.958 11 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    points: "7 12 0.336 5.097 4 0.958 11 8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35,15 L37,15",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.625,25.0132 C22.492,25.7382 23.642,26.2772 25,26.2772 C26.358,26.2772 27.578,25.7152 28.375,25.0132",
    id: "Stroke-33",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-35",
    fill: "#FFFFFF",
    points: "33 59 44 59 44 53 33 53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,58 C21,57.399 20.729,56.867 20.311,56.5 C20.729,56.133 21,55.601 21,55 C21,53.896 20.104,53 19,53 L10,53 C10,53 10.5,51.458 10.708,50.542 C11.047,49.052 9.657,47 8,47 C6.875,49.667 4,54.25 4,58.5 C4,58.671 4.015,58.835 4.026,59 L20.706,59 C20.882,58.705 21,58.37 21,58",
    id: "Fill-37",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,51 L14,51 C14,51 14.5,49.458 14.708,48.542 C15.047,47.052 13.657,45 12,45 C10.875,47.667 8,52.25 8,56.5 C8,60.5 11.417,63 14.292,63 L20,63 C21.104,63 22,62.104 22,61 C23.104,61 24,60.104 24,59 C24,58.585 23.873,58.2 23.657,57.88 C24.437,57.607 25,56.873 25,56 C25,55.399 24.729,54.867 24.311,54.5 C24.729,54.133 25,53.601 25,53 C25,51.896 24.104,51 23,51",
    id: "Fill-39",
    fill: "#F0C6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,14 C21,14.552 20.553,15 20,15 C19.447,15 19,14.552 19,14 C19,13.448 19.447,13 20,13 C20.553,13 21,13.448 21,14",
    id: "Fill-41",
    fill: "#78818C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,14 C31,14.552 30.553,15 30,15 C29.447,15 29,14.552 29,14 C29,13.448 29.447,13 30,13 C30.553,13 31,13.448 31,14",
    id: "Fill-43",
    fill: "#78818C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.2296537bbab309bb9bb0e7417fc104df.svg";
export { ForwardRef as ReactComponent };